import React, { useEffect, useState } from "react";
import AssociateFamily from "../../common/NucleoFamiliare/AssociateFamily";
import {
  useGetDetailsFamilyUserQuery,
  useGetDetailsChildrenUserQuery,
  useDoDeleteFamilyMutation,
  useDoDeleteChildrenMutation,
  useDoEditFamilyMutation,
  useDoCreateFamilyMutation,
  useDoCreateChildrenMutation,
  useDoEditChildrenMutation,
} from "../../api/user/modificaProfiloApi";
import { toast } from "react-toastify";

const UserFamilyComponent = () => {
  const [family, setFamily] = useState([]);
  const [children, setChildren] = useState([]);
  const {
    data: dataFamily,
    isLoading: isLoadingFamily,
    isFetching: isFetchingFamily,
  } = useGetDetailsFamilyUserQuery();
  const {
    data: dataChildren,
    isLoading: isLoadingChildren,
    isFetching: isFetchingChildren,
  } = useGetDetailsChildrenUserQuery();

  const [doDeleteFamily, { isLoading: isDeletingFamily }] =
    useDoDeleteFamilyMutation();
  const [doDeleteChildren, { isLoading: isDeletingChildren }] =
    useDoDeleteChildrenMutation();
  const [doEditFamily, { isLoading: isEditingFamily }] =
    useDoEditFamilyMutation();
  const [doEditChildren, { isLoading: isEditingChildren }] =
    useDoEditChildrenMutation();
  const [doCreateFamily, { isLoading: isCreatingFamily }] =
    useDoCreateFamilyMutation();
  const [doCreateChildren, { isLoading: isCreatingChildren }] =
    useDoCreateChildrenMutation();

  useEffect(() => {
    if (dataFamily && dataFamily.Data) {
      setFamily(dataFamily.Data);
    }
  }, [dataFamily]);

  useEffect(() => {
    if (dataChildren && dataChildren.Data) {
      setChildren(dataChildren.Data);
    }
  }, [dataChildren]);

  const handleDeleteFamily = (id) => {
    doDeleteFamily(id).then((res) => {
      if (res.data.Result === 1) {
        toast.success("Familiare eliminato");
      } else {
        toast.error("Errore: " + res.data.Exception);
      }
    });
  };

  const handleDeleteChildren = (id) => {
    doDeleteChildren(id).then((res) => {
      if (res.data.Result === 1) {
        toast.success("Figlio/a eliminato");
      } else {
        toast.error("Errore: " + res.data.Exception);
      }
    });
  };
  return (
    <AssociateFamily
      hideTitle={true}
      family={family}
      children={children}
      isLoadingMember={
        isFetchingChildren ||
        isFetchingFamily ||
        isLoadingChildren ||
        isLoadingFamily
      }
      onCreateFamily={doCreateFamily}
      onCreateChildren={doCreateChildren}
      onDeleteChildren={handleDeleteChildren}
      onDeleteFamily={handleDeleteFamily}
      onEditFamily={doEditFamily}
      onEditChildren={doEditChildren}
      isLoading={
        isDeletingFamily ||
        isDeletingChildren ||
        isEditingFamily ||
        isEditingChildren ||
        isCreatingFamily ||
        isCreatingChildren
      }
    />
  );
};

export default UserFamilyComponent;
